// import i18n from '@/i18n'
// import jobList from './jobList.vue'
import { deviceType } from '@/utils/common'
import PcRoute from './pc/route'
import MobileRoute from './mobile/route'
import PcIndex from './pc/index.vue'
import MobileIndex from './mobile/index.vue'

const basePath = '/msdchina'

const childrenRoute = deviceType.isPc ? PcRoute : MobileRoute

export default {
  path: basePath,
  component: deviceType.isPc ? PcIndex : MobileIndex,
  meta: {
    noAuth: true
  },
  children: childrenRoute
}
